import React from 'react';
import { getCountryFlag } from '@home/_config/countries';
import TextBubbles from '@home/components/TextBubbles';
import classnames from 'classnames';
import { transCountryText } from '@op/utils';
import './index.scss';


export type CountryLabelProps = {
  country: string;
  style?: React.CSSProperties;
  className?: string;
  showText?: boolean;
  newText?: string;
  iconStyle?: React.CSSProperties;
  bubbleProps?: any;
};


export default function CountryLabel({
  country,
  style,
  iconStyle,
  className,
  showText = false,
  newText,
  bubbleProps = {}
}: CountryLabelProps) {
  return (
    <div className={classnames(`dbom-country-label`, className)} style={style}>
      {
        getCountryFlag(country) && (
          <img
            src={getCountryFlag(country)}
            style={iconStyle}
            className={`dbom-country-label-icon ${className}`}
          />
        )
      }
      {showText && (
        <TextBubbles
          rowNum={1}
          text={newText ? newText : transCountryText(country)}
          className={classnames(`dbom-country-label-text`, className)}
          {...bubbleProps}
        />
      )}
    </div>
  );
} 